<template>
  <div class="black-list main-second-bg">
    <p class="user-management-child-header b-1-cl a-3-bd">{{ $t("personal.blackList.title") }}</p>
    <div class="center clearfix">
      <c-table
        :imgMap="imgMap"
        :colorMap="colorMap"
        :loading="loading"
        :classes="classes"
        :headClasses="headClasses"
        :bodyClasses="bodyClasses"
        :lineClasses="lineClass"
        :columns="columns"
        :dataList="dataList"
        :lineNumber="lineNumber"
        :cellHeight="cellHeight"
        :headHeight="headHeight"
        @elementClick="closeData"
      />
      <c-pagination
        v-show="count > 10"
        :total="count"
        :current-page="page"
        :display="pageSize"
        @pagechange="pagechange"
      >
      </c-pagination>
    </div>
    <c-dialog
      :showFlag="dialogFlag"
      paddingBottom="14px"
      :confirmLoading="dialogConfirmLoading"
      :confirmDisabled="dialogConfirmDisabled"
      @close="dialogClose"
      @confirm="dialogConfirm"
      :titleText="titleText"
    >
      <p class="dialog-p">{{ $t("personal.dialog.blackPromptText") }}</p>
    </c-dialog>
  </div>
</template>

<script>
import { nul, imgMap, colorMap } from '@/utils';

export default {
  name: 'blackList',
  watch: {
    otcPersonRelationship(otcPersonRelationship) {
      if (otcPersonRelationship !== null) {
        this.loading = false;
        this.dataProcessin(otcPersonRelationship.data);
      }
    },
    otcUserContactsRemove(otcUserContactsRemove) {
      if (otcUserContactsRemove !== null) {
        if (otcUserContactsRemove.text === 'success') {
          this.$bus.$emit('tip', { text: otcUserContactsRemove.msg, type: 'success' });
          this.$store.dispatch('resetType');
          this.dialogFlag = false;
          const info = { relationType: 'BLACKLIST', page: this.page, pageSize: this.pageSize };
          this.$store.dispatch('otcPersonRelationship', info);
          this.loading = true;
        } else {
          this.$bus.$emit('tip', { text: otcUserContactsRemove.msg, type: 'error' });
          this.$store.dispatch('resetType');
        }
      }
    },
  },
  computed: {
    otcPersonRelationship() {
      return this.$store.state.personal.otcPersonRelationship;
    },
    otcUserContactsRemove() {
      return this.$store.state.fiatdeal.otcUserContactsRemove;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const info = { relationType: 'BLACKLIST', page: this.page, pageSize: this.pageSize };
      this.$store.dispatch('otcPersonRelationship', info);
      this.loading = true;
    },
    dialogClose() {
      this.dialogFlag = false;
    },
    dialogConfirm() {
      const info = { friendId: this.uid };
      this.$store.dispatch('otcUserContactsRemove', info);
    },
    closeData(name, id) {
      this.dialogFlag = true;
      this.uid = id;
    },
    pagechange(page) {
      this.page = page;
      const info = { relationType: 'BLACKLIST', page: this.page, pageSize: this.pageSize };
      this.$store.dispatch('otcPersonRelationship', info);
      this.loading = true;
    },
    dataProcessin(data) {
      this.count = data.count;
      const list = [];
      data.relationshipList.forEach((obj) => {
        list.push({
          id: obj.userId,
          data: [
            obj.otcNickName,
            `${nul(obj.creditGrade, 100)}%`,
            obj.completeOrders,
            obj.completeOrders,
            [
              {
                type: 'button', // 'link' ' button' ,'html', 'label', 'icon' ‘str’
                text: this.$t('personal.blackList.closeText'),
                iconClass: [''],
                eventType: 'close',
                classes: [''],
              },
            ],
          ],
        });
      });
      this.dataList = list;
    },
  },
  data() {
    return {
      imgMap,
      colorMap,
      titleText: this.$t('personal.dialog.blackPrompt'),
      // table loading
      loading: false,
      uid: '',
      // table相关
      columns: [
        {
          title: this.$t('personal.blackList.columns')[0],
          align: 'left',
          width: '100px',
          classes: '',
        },
        {
          title: this.$t('personal.blackList.columns')[1],
          align: 'left',
          width: '100px',
        },
        {
          title: this.$t('personal.blackList.columns')[2],
          align: 'left',
          width: '100px',
        },
        {
          title: this.$t('personal.blackList.columns')[3],
          align: 'left',
          width: '100px',
        },
        {
          title: this.$t('personal.blackList.columns')[4],
          align: 'left',
          width: '150px',
        },
      ],
      dataList: [],
      cellHeight: 55,
      headHeight: 30,
      lineNumber: 10,
      classes: '',
      headClasses: '',
      bodyClasses: '',
      lineClass: '',
      // page相关
      count: 0,
      page: 1,
      pageSize: 10,
      // 弹框
      dialogFlag: false,
      dialogConfirmLoading: false,
      dialogConfirmDisabled: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.black-list {
  width: 100%;
  min-height: 800px;
  border-radius: 6px;

  .user-management-child-header {
    font-size: 14px;
    padding: 18px 0 18px 20px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    box-sizing: border-box;
  }
  .dialog-p {
    font-size: 14px;
  }
}
</style>
